import { render, staticRenderFns } from "./PasswordResetView.vue?vue&type=template&id=8541cfb8&scoped=true"
import script from "./PasswordResetView.vue?vue&type=script&lang=js"
export * from "./PasswordResetView.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetView.vue?vue&type=style&index=0&id=8541cfb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8541cfb8",
  null
  
)

export default component.exports